import React from 'react'
import { FoundationsComponent } from '../Types/FoundationsTypes'

export function FoundationsGeneric(props: FoundationsComponent) {
    return (
        <span id={props.id} style={props.customStyle || {}} className={props.classes || ''}>
            {props.children}
        </span>
    )
}
